import type { EmployeeWithBeneficiariesFormatted } from '@/api/employees/employees.types';
import { Table } from '@/components/table/Table';
import { useTableState } from '@/components/table/useTableState';
import { useCommiteeSlugNavigate } from '@/utils/router';
import { activitiesColumns } from '../columns/activities-columns.tsx';

interface EmployeeActivitiesProps {
  employee: EmployeeWithBeneficiariesFormatted;
  search: string;
  dateFilter?: Date | null;
}

export function EmployeeActivities(props: EmployeeActivitiesProps) {
  const { employee, search, dateFilter } = props;
  const activities = employee.beneficiary?.prestationParticipations;
  const tableState = useTableState('employee-activities', { columns: activitiesColumns });
  const navigate = useCommiteeSlugNavigate();

  return (
    <Table
      entity={{ singular: 'activité', feminine: true }}
      data={activities}
      columns={activitiesColumns}
      search={search}
      onRowClick={(participation) =>
        navigate({
          to: '/$commiteeSlug/prestation-participations/{-$id}',
          params: { id: participation.id.toString() },
        })
      }
      // The parent's DatePicker owns the date column and stays ephemeral: it is injected over
      // the controller's filters so it is neither persisted nor cleared by the reset strip.
      tableState={{
        ...tableState,
        columnFilters: [
          ...tableState.columnFilters.filter((filter) => filter.id !== 'date'),
          ...(dateFilter ? [{ id: 'date', value: dateFilter }] : []),
        ],
      }}
    />
  );
}
